function drawStar(ctx, x, y, radius, points, innerRadius) {
  ctx.save(); // Save the current state
  ctx.translate(x, y); // Move the origin to the star's center
  ctx.rotate(Math.PI / 5); // Rotate by 18 degrees (π/10 radians)
  ctx.translate(-x, -y); // Move the origin back

  ctx.beginPath();
  ctx.moveTo(x, y + radius);
  for (let i = 0; i < 2 * points; i++) {
    const angle = (i * Math.PI) / points;
    const r = i % 2 === 0 ? radius : innerRadius;
    ctx.lineTo(x + r * Math.sin(angle), y + r * Math.cos(angle));
  }
  ctx.closePath();
  ctx.fillStyle = '#B8860B'; // Darker gold color
  ctx.fill();

  ctx.restore(); // Restore the previous state
}

function getGridPosition({ index, columns, order }) {
  if (columns <= 0) return { col: 0, row: 0 };
  if (order === 'column') {
    const rows = Math.ceil((index + 1) / columns);
    const col = Math.floor(index / rows);
    const row = index % rows;
    return { col, row };
  }
  const col = index % columns;
  const row = Math.floor(index / columns);
  return { col, row };
}

function createGridTemplate({ padding, videoWidth, videoHeight, columns, order, includeMainVideo }) {
  return {
    padding,
    videoWidth,
    videoHeight,
    includeMainVideo,
    initCanvas: ({ canvas, videosCount, videoWidth, videoHeight, padding }) => {
      const cols = Math.max(1, Math.min(columns, videosCount || 1));
      const rows = Math.max(1, Math.ceil((videosCount || 1) / cols));
      canvas.width = cols * videoWidth + 2 * padding;
      canvas.height = rows * videoHeight + 2 * padding;
    },
    shouldResizeOnVideosCountChange: true,
    resizeCanvas: ({ canvas, videosCount, videoWidth, videoHeight, padding }) => {
      const cols = Math.max(1, Math.min(columns, videosCount || 1));
      const rows = Math.max(1, Math.ceil((videosCount || 1) / cols));
      canvas.width = cols * videoWidth + 2 * padding;
      canvas.height = rows * videoHeight + 2 * padding;
    },
    drawBackground: () => {},
    getVideoPosition: ({ index, padding, videoWidth, videoHeight }) => {
      const { col, row } = getGridPosition({ index, columns, order });
      const x = padding + col * videoWidth;
      const y = padding + row * videoHeight;
      return { x, y };
    },
    afterDrawVideo: () => {},
  };
}

export const CDN_PREVIEW_TEMPLATES = {
  facesOnly: {
    padding: 0,
    videoWidth: 320,
    videoHeight: 240,
    includeMainVideo: false,
    initCanvas: ({ canvas, videosCount, videoWidth, videoHeight, padding }) => {
      canvas.width = videoWidth;
      canvas.height = videoHeight * videosCount + 3 * padding;
    },
    shouldResizeOnVideosCountChange: true,
    resizeCanvas: ({ canvas, videosCount, videoHeight }) => {
      canvas.height = videoHeight * videosCount;
    },
    drawBackground: () => {},
    getVideoPosition: ({ index, videoHeight }) => ({ x: 0, y: index * (videoHeight + 5) }),
    afterDrawVideo: ({ ctx, canvas, index, videoWidth, videoHeight, isStarRequired }) => {
      if (index !== 0) return;
      ctx.strokeStyle = '#FFD700';
      ctx.lineWidth = 5;
      ctx.strokeRect(0, 0, videoWidth, videoHeight);
      if (isStarRequired) {
        drawStar(ctx, canvas.width - 30, 30, 15, 5, 7.5);
      }
    },
  },
  facesOnlyHD: {
    padding: 0,
    videoWidth: 640,
    videoHeight: 480,
    includeMainVideo: false,
    initCanvas: ({ canvas, videosCount, videoWidth, videoHeight }) => {
      canvas.width = videoWidth;
      canvas.height = videoHeight * videosCount;
    },
    shouldResizeOnVideosCountChange: true,
    resizeCanvas: ({ canvas, videosCount, videoHeight }) => {
      canvas.height = videoHeight * videosCount;
    },
    drawBackground: () => {},
    getVideoPosition: ({ index, videoHeight }) => ({ x: 0, y: index * videoHeight }),
    afterDrawVideo: ({ ctx, canvas, index, videoWidth, videoHeight, isStarRequired }) => {
      if (index !== 0) return;
      ctx.strokeStyle = '#FFD700';
      ctx.lineWidth = 5;
      ctx.strokeRect(0, 0, videoWidth, videoHeight);
      if (isStarRequired) {
        drawStar(ctx, canvas.width - 60, 60, 30, 5, 15);
      }
    },
  },
  facesOnlyHDLandscape: createGridTemplate({
    padding: 0,
    videoWidth: 640,
    videoHeight: 360,
    columns: 2,
    order: 'row',
    includeMainVideo: false,
  }),
  facesOnlyHDPortrait: createGridTemplate({
    padding: 0,
    videoWidth: 480,
    videoHeight: 640,
    columns: 2,
    order: 'column',
    includeMainVideo: false,
  }),
  default: {
    padding: 24,
    videoWidth: 200,
    videoHeight: 150,
    includeMainVideo: true,
    initCanvas: () => {},
    shouldResizeOnVideosCountChange: false,
    resizeCanvas: () => {},
    drawBackground: ({ ctx, canvas, player }) => {
      if (!player) return;
      ctx.drawImage(player, 0, 0, canvas.width, canvas.height);
    },
    getVideoPosition: ({ index, padding, videoHeight }) => ({ x: padding, y: 2 * padding + 10 + index * (videoHeight + 5) }),
    afterDrawVideo: () => {},
  },
  withMainVideo: {
    padding: 24,
    videoWidth: 200,
    videoHeight: 150,
    includeMainVideo: true,
    initCanvas: () => {},
    shouldResizeOnVideosCountChange: false,
    resizeCanvas: () => {},
    drawBackground: ({ ctx, canvas, player }) => {
      if (!player) return;
      ctx.drawImage(player, 0, 0, canvas.width, canvas.height);
    },
    getVideoPosition: ({ index, padding, videoHeight }) => ({ x: padding, y: 2 * padding + 10 + index * (videoHeight + 5) }),
    afterDrawVideo: () => {},
  },
};

export function resolveCdnPreviewTemplateKey({ cdnPreviewTemplate }) {
  if (cdnPreviewTemplate && CDN_PREVIEW_TEMPLATES[cdnPreviewTemplate]) return cdnPreviewTemplate;
  return 'default';
}
